import {HttpClient} from '@angular/common/http';
import 'rxjs/add/operator/catch';
import {Injectable} from '@angular/core';
import {ApiEndpoints} from '../ApiEndpoints';
import {ApiUtils} from '../ApiUtils';
import 'rxjs/add/operator/map';
import {Partenaire} from '../../model/partenaire';
// import {SharedMethods} from "../../../util/sharedMethods";
// import {NetworkService} from "../../../util/NetworkService";

import { SharedMethods } from '../../../../util/sharedMethods-service';
import { plainToClass } from 'class-transformer';


@Injectable()
export class PartenaireService {

  localPartnersClient: Partenaire[];
  localPartnersFournisseur: Partenaire[];
  localPartnersEmploye: Partenaire[];
  localPartnersVendeur: Partenaire[];
  localPartnersInvetaireFournisseur: Partenaire[];
  localPartnersInventaireClient: Partenaire[];
  localPartnersAll: Partenaire[];

  iSconnecting = false;

  constructor(public apiEndpoints: ApiEndpoints, public http: HttpClient,
              public apiUtils: ApiUtils,
              // public networkService:NetworkService,
              public sharedMethods: SharedMethods,
              ) { }

  getAllPartner() {
    this.iSconnecting = true;
    return new Promise<Partenaire[]>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_ALL_PARTNER(),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Partenaire[]) => {
              const partenaires = plainToClass(Partenaire, data);
              this.setLocalPartner('all', partenaires);
              resolve(partenaires);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
    });

  }


  getPartner(type: string) {

    this.iSconnecting = true;
    return new Promise<Partenaire[]>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_PARTNER(type),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Partenaire[]) => {
              const partenaires = plainToClass(Partenaire, data);
              this.setLocalPartner(type, partenaires);
              resolve(partenaires);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
    });


    /* this.http.get(this.apiEndpoints.URL_GET_PRODUITS,
      {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
      .subscribe(data => {
          // resolve(data);
          alert(JSON.stringify(data));
          // alert('ok');
        },
        err => {
          // console.log(err);
          alert(JSON.stringify(err));
    }); */

  }


  inventaire(type: string) {

    this.iSconnecting = true;
    return new Promise<Partenaire[]>(resolve => {
        this.http.get(this.apiEndpoints.URL_GET_PARTNERINVENTAIRE(type),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe((data: Partenaire[]) => {
              const partenaires = plainToClass(Partenaire, data);
              this.setLocalInventaire(type, partenaires);
              resolve(partenaires);
              this.iSconnecting = false;
            },
            err => {
              // console.log(err);
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              this.iSconnecting = false;
            });
    });

  }

  savePartner(partner: Partenaire, type: string) {

      let idplan = null;
      if (partner.plan_tarifaire !== undefined && partner.plan_tarifaire !== null)
      idplan = partner.plan_tarifaire.id;

      let id_taxes: number[];


      if ( partner.taxes !== undefined && partner.taxes !== null && partner.taxes.length > 0 ) {

        id_taxes = [];

        for ( let i = 0; i < partner.taxes.length; i++) {
          id_taxes.push(partner.taxes[i].id);
        }

      }

      this.iSconnecting = true;
      const pat = {
        nom: partner.nom,
        tel: partner.tel,
        email: partner.email,
        typePartenaire: type,
        pays: partner.pays,
        ville: partner.ville,
        adresse: partner.adresse,
        planTarifaire: idplan,
        creanceLimit: partner.creance_limit,
        bp: partner.bp,
        numContribuable: partner.num_contribuable,
        rc: partner.rc,
        taxes: id_taxes,
      };


      if (partner.id !== 0) {

        this.iSconnecting = true;

        return new Promise<Partenaire>(resolve => {
          this.http.put(this.apiEndpoints.GET_URL_PUT_PARTNER(partner.id), pat,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Partenaire) => {

                this.getPartner(type).then( () => {

                  this.getAllPartner().then( () => {
                    resolve(data);
                    this.iSconnecting = false;
                  });

                });


              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }else {

        return new Promise<Partenaire>(resolve => {
          this.http.post(this.apiEndpoints.GET_URL_POST_PARTNER, pat,
            {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
            .subscribe((data: Partenaire) => {

              this.getPartner(type).then( () => {

                this.getAllPartner().then( () => {
                  resolve(data);
                  this.iSconnecting = false;
                });

              });

              },
              err => {
                this.sharedMethods.errorApiShow(err.error.code, err.error.message);
                // alert(JSON.stringify(err));
                this.iSconnecting = false;
              });
        });

      }



    }

    deletePartner(partner: Partenaire, type: string) {
      this.iSconnecting = true;
      return new Promise(resolve => {
        this.http.delete(this.apiEndpoints.GET_URL_DELETE_PARTNER(partner.id),
          {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()})
          .subscribe(data => {

            this.getPartner(type).then( () => {

              this.getAllPartner().then( () => {
                resolve(data);
                this.iSconnecting = false;
              });

            });

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      });


    }

    setLocalPartner(type: string, partners: Partenaire[]) {

      if (type === 'client')
      this.localPartnersClient = partners ;

      if (type === 'fournisseur')
      this.localPartnersFournisseur = partners;

      if (type === 'employe')
      this.localPartnersEmploye = partners ;

      if (type === 'vendeur')
      this.localPartnersVendeur = partners;

      if (type === 'all')
      this.localPartnersAll = partners;

    }

    getLocalPartner(type: string) {

      if (type === 'client')
      return this.localPartnersClient;

      if (type === 'fournisseur')
      return this.localPartnersFournisseur;

      if (type === 'employe')
      return this.localPartnersEmploye;

      if (type === 'vendeur')
      return this.localPartnersVendeur;

      if (type === 'all')
      return this.localPartnersAll;

    }


    setLocalInventaire(type: string, partners: Partenaire[]) {

      if (type === 'vente')
      this.localPartnersInventaireClient = partners ;

      if (type === 'achat')
      this.localPartnersInvetaireFournisseur = partners;

    }

    getLocalInventaire(type: string) {

      if (type === 'vente')
      return this.localPartnersInventaireClient;

      if (type === 'achat')
      return this.localPartnersInvetaireFournisseur;

    }


}
